import React from "react";
import { FaSyncAlt } from "react-icons/fa";

import { formatNumber } from "../utils/dashboardUtils";

export default function DashboardHero({
  loading,
  refreshing,
  clubInfo,
  userInfo,
  stats,
  onRefresh,
}) {
  const firstname = userInfo?.prenom || "";
  const clubName = clubInfo?.nom || "votre club";

  return (
    <section className="relative overflow-hidden rounded-[2rem] border border-slate-200 bg-slate-950 p-6 text-white shadow-xl shadow-slate-300/40 dark:border-slate-800 dark:shadow-none lg:p-8">
      <div className="absolute -right-20 -top-24 h-64 w-64 rounded-full bg-orange-500/30 blur-3xl" />
      <div className="absolute -bottom-28 left-1/3 h-72 w-72 rounded-full bg-blue-500/20 blur-3xl" />

      <div className="relative flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.24em] text-orange-200">
            Tableau de bord administrateur
          </p>

          <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
            {loading
              ? "Chargement du tableau de bord..."
              : `Bonjour ${firstname || "Admin"}, prêt à gérer ${clubName} ?`}
          </h1>

          <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-300 sm:text-base">
            Retrouvez ici les informations importantes du club : derniers
            adhérents, messages du formulaire de contact, notifications,
            visites du site et répartition des effectifs.
          </p>
        </div>

        <div className="grid gap-3 sm:grid-cols-3 xl:min-w-[440px]">
          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Adhérents
            </p>
            <p className="mt-2 text-3xl font-bold">
              {formatNumber(stats.totalAdherents)}
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Messages non lus
            </p>
            <p className="mt-2 text-3xl font-bold">
              {formatNumber(stats.unreadMessages)}
            </p>
          </div>

          <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur">
            <p className="text-xs uppercase tracking-[0.18em] text-slate-300">
              Notifications
            </p>
            <p className="mt-2 text-3xl font-bold">
              {formatNumber(stats.unreadNotifications)}
            </p>
          </div>
        </div>
      </div>

      <div className="relative mt-6 flex flex-wrap items-center gap-3">
        <button
          type="button"
          onClick={onRefresh}
          disabled={refreshing}
          className="inline-flex items-center gap-2 rounded-2xl bg-white px-4 py-2.5 text-sm font-bold text-slate-950 shadow-lg shadow-black/20 transition hover:-translate-y-0.5 hover:bg-orange-50 disabled:cursor-not-allowed disabled:opacity-70"
        >
          <FaSyncAlt className={refreshing ? "animate-spin" : ""} />
          {refreshing ? "Actualisation..." : "Actualiser les données"}
        </button>

        <span className="rounded-full border border-white/10 bg-white/10 px-4 py-2 text-sm text-slate-300">
          Interface optimisée pour une gestion quotidienne du club
        </span>
      </div>
    </section>
  );
}